import * as React from 'react';
import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Api } from "../../helpers/Api";
import { connect } from "react-redux";
import { extractError } from "../../helpers/Utils";
import { useNavigate } from "react-router-dom";

function Copyright(props) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="https://chitkara.edu.in/">
                Chitkara University
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}


const Login = ({ dispatchLogin }) => {

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        window.localStorage.clear();
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        let payload = {
            identifier: data.get('identifier'),
            password: data.get('password'),
        }
        setLoading(true);
        Api.login(payload).then(user => {
            dispatchLogin(user);
            navigate("/home")

        }).catch(e => {
            console.log(e);
        }).finally(() => {
            setLoading(false);
        })
    };

    return (<div className='main-login'>
        <div className='login-form-new'>
            <div className='login-logo'>
                <img src='../../../../images/main-logo.svg' alt='Logo' />
            </div>
            <div className='login-text-new'>
                <h4>Log in</h4>
                <span>Welcome back! Please enter your details.</span>
            </div>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="identifier"
                    label="Email Address"
                    name="identifier"
                    autoComplete="identifier"
                    autoFocus
                />
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                />
                {/* <div className='forgot-password'> */}
                <div className='forgot-password login-text-new'>
                    {/* <Link href="#" variant="body2"> */}
                    <span> Contact With Admin To Change Password </span>
                    {/* </Link> */}
                </div>
                {/* </div> */}
                <div className='login-button'>
                    <Button
                        type="submit"
                        fullWidth
                        disabled={loading}
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        {loading ? 'Please wait..' : 'Sign In'}
                    </Button>
                </div>
            </Box>
            <Copyright sx={{ mt: 8, mb: 4 }} />
        </div>
    </div>)
}
const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchLogin: (user) => dispatch({ type: 'LOGIN', data: user })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login)
